import React, { Component, createRef } from 'react';
import './Visualizer.css';

let ctx, x_end, y_end, bar_height,audioOf, isFilePicked=false;

const width = window.innerWidth-100;
const height = window.innerHeight-100;
const bars = 800;
const bar_width = 1;
const radius = 0;
const center_x = width / 2;
const center_y = height / 2;


class Visualizer extends Component {
	constructor(props) {
		super(props);
		this.audio = null;
		this.canvas = createRef();
		this.state={
			clicked : false
		}
	}

	animationLooper(canvas) {
		canvas.width = width;
		canvas.height = height;

		ctx = canvas.getContext("2d");

		const rads = Math.PI * 6 / bars;
		for (var i = 20; i < bars; i++) {

			bar_height = this.frequency_array[i] * 1.5;
			if(i<20){
				bar_height = this.frequency_array[i] * 1;
			}


			const x = center_x + Math.cos(rads * i) * (radius);
			const y = center_y + Math.sin(rads * i) * (radius);
			x_end = center_x + Math.cos(rads * i) * (radius + bar_height);
			y_end = center_y + Math.sin(rads * i) * (radius + bar_height);

			this.drawBar(center_x, center_y, x_end, y_end, this.frequency_array[i], ctx, canvas);
		}
	}

	drawBar(x1=0, y1=0, x2=0, y2=0, frequency, ctx, canvas) {
		const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
		gradient.addColorStop(0, "rgb(133,125,145)");
		gradient.addColorStop(1, "rgb(44,200,119)");
		ctx.fillStyle = gradient;

		const lineColor = "rgb(" + frequency + ", " + frequency + ", " + 205 + ")";
		ctx.strokeStyle = lineColor;
		ctx.lineWidth = bar_width;
		ctx.beginPath();
		ctx.moveTo(x1, y1);
		ctx.lineTo(x2, y2);
		ctx.stroke();
	}

	componentDidMount() {

		this.context = new (window.AudioContext || window.webkitAudioContext)();
		try {
			if (audioOf != null) {
				this.source = this.context.createMediaElementSource(audioOf);
				this.analyser = this.context.createAnalyser();
				this.source.connect(this.analyser);
				this.analyser.connect(this.context.destination);
				this.frequency_array = new Uint8Array(this.analyser.frequencyBinCount);
			}
		}
		catch (e){}


	}

	togglePlay = () => {
		if(audioOf!=null) {
			if (audioOf.paused) {
				audioOf.play();
				this.setState({clicked: true});
				this.rafId = requestAnimationFrame(this.tick);
				this.componentDidMount();

			} else {
				this.setState({clicked: false});
				console.log(this.clicked);
				audioOf.pause();
				cancelAnimationFrame(this.rafId);
			}
		}
	}

	tick = () => {
		this.animationLooper(this.canvas.current);
		this.analyser.getByteFrequencyData(this.frequency_array);
		this.rafId = requestAnimationFrame(this.tick);
	}

	componentWillUnmount() {
		if(audioOf!=null) {
			cancelAnimationFrame(this.rafId);
			this.analyser.disconnect();
			this.source.disconnect();
		}
	}

	changeHandler = (event) => {

		if(event.target.files[0]!=null) {
			this.setState({selectedFile:event.target.files[0]});
			var reader = new FileReader();
			reader.readAsDataURL(event.target.files[0]);
			this.setState({clicked: false});

			reader.addEventListener("load", function () {
				if (audioOf != null) audioOf.pause();
				cancelAnimationFrame(this.rafId);
				audioOf = new Audio();
				audioOf.title = event.target.files[0].name;
				audioOf.src = this.result;
				isFilePicked = true;
				//audioOf.play();

			}, false);
		}

		this.setState({audio:new Audio(event.target.files[0])});
	};

	handleSubmission = () => {

	};


	render() {
		return <div className='visualizer'>
			<input type="file" name="file" onChange={this.changeHandler} className='picker' accept='audio/mp3, audio/wav' />
			<br/>
			<div>
				<canvas ref={this.canvas}/>
			</div>
			{this.state.audio!=null?<button className='btnResume' onClick={this.togglePlay}>{this.state.clicked?"Zatrzymaj":"Wznów"}</button>:null}
		</div>
	}
}

export default Visualizer;